import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React from 'react';
import fuzzyFilter from '../filters/fuzzy.js';
import noneFilter from '../filters/none.js';
import startsWithFilter from '../filters/startsWith.js';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function createBoldArray(idxArray) {
  var boldArray = [];
  for (var x = 0; x < idxArray.length; x++) {
    var start = idxArray[x];
    while (idxArray[x] + 1 === idxArray[x + 1]) {
      x++;
    }
    var end = idxArray[x] + 1;
    boldArray.push([start, end]);
  }
  return boldArray;
}
function sliceLabel(label, boldArray) {
  var slicedLabel = [];
  var beginSplit = 0;
  var _iterator = _createForOfIteratorHelper(boldArray),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        start = _step$value[0],
        end = _step$value[1];
      slicedLabel.push(label.slice(beginSplit, start));
      slicedLabel.push(label.slice(start, end));
      beginSplit = end;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  slicedLabel.push(label.slice(beginSplit, label.length));
  return slicedLabel;
}
function boldString(label, filter, searchText) {
  // none filter and jsx options
  if (filter === noneFilter || typeof label !== 'string') {
    return label;
  }
  var newLabel = label;
  var idxArray = [];
  var boldArray = [];

  // fuzzy filter
  if (filter === fuzzyFilter) {
    var compareString = newLabel.toString().toLowerCase();
    var searchString = searchText.toString().toLowerCase().trim();
    var compareIndex = 0;
    for (var index = 0; index < compareString.length; index++) {
      if (compareString[index] === searchString[compareIndex]) {
        compareIndex++;
        if (compareIndex === searchString.length) {
          compareIndex = 0;
        }
        idxArray.push(index);
      }
    }
    while (compareIndex > 0) {
      idxArray.pop();
      compareIndex--;
    }
    boldArray = createBoldArray(idxArray);

    // contains filter, custom filter & startsWith filter
  } else {
    var re = new RegExp(searchText, 'gi');
    var match;
    while ((match = re.exec(newLabel)) !== null) {
      boldArray.push([match.index, re.lastIndex]);
      if (filter === startsWithFilter) {
        break;
      }
    }
  }
  var slicedLabel = sliceLabel(newLabel, boldArray);
  return slicedLabel.map(function (str, index) {
    if (str === '') {
      return;
    }
    if (index % 2 === 0) {
      return /*#__PURE__*/React.createElement("span", {
        key: "".concat(str, "_").concat(index)
      }, str);
    } else {
      return /*#__PURE__*/React.createElement("strong", {
        key: "".concat(str, "_").concat(index)
      }, str);
    }
  });
}

export { createBoldArray, boldString as default, sliceLabel };
